<template>
  <vs-popup :active.sync="modalActive" title="">
    <div class="row mt-2">
      <label for="title">Title</label>
      <vs-input v-model="item.title" class="w-full"></vs-input>
    </div>
    <div class="row mt-2">
      <label for="description">Description</label>
      <quill-editor v-model="item.content" class="w-full"></quill-editor>
    </div>
    <div class="w-full mt-4 flex justify-end">
      <vs-button color="success" type="border" @click="saveNewKbItem"
        >{{ $t('save') }}</vs-button
      >
    </div>
  </vs-popup>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { storeNewKbItem } from "../../../../api/knowledgebase";

export default {
  name: "AddKnowledgeBaseItem",
  props: {
    kbItemActive: {
      required: true,
      type: Boolean
    },
    parent: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    item: {
      title: "",
      content: "",
      parent_id: null
    }
  }),
  computed: {
    modalActive: {
      get() {
        return this.$props.kbItemActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeKbItemActive");
        }
      }
    }
  },
  methods: {
    saveNewKbItem() {
      this.item.parent_id = this.$props.parent;
      storeNewKbItem(this.item).then(res => {
        this.clearDatas();
        this.$emit("pushKbItem", res.data.data);
      });
    },
    clearDatas() {
      this.item.title = "";
      this.item.content = "";
      this.item.parent_id = null;
    }
  },
  components: {
    quillEditor
  }
};
</script>
<style>
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  min-height: 10rem;
}
.ql-editor {
  min-height: 10rem;
}
</style>
